import React, { useState, useEffect } from "react"
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types'
import packageJson from '../../package.json';

import { GetTheme, SetTheme } from "./Themes"
import { Translate } from "./Translator"
import { PushApiSetBrowserNotificationSetting, PushApiAddBrowserNotification } from "../ExternalApi/PushApi"
import { UrlBase64ToUint8Array } from "./GeneralFunctions"

import ActionPngLight from '../Assets/action_lightbg.png'
import ActionPngDark from '../Assets/action_darkbg.png'

//Telephony settings
import TelephonySettingsAmiba from './TelephonySettings/TelephonySettingsAmiba'
import TelephonySettingsAvaya from './TelephonySettings/TelephonySettingsAvaya'
import TelephonySettingsBroadsoft from './TelephonySettings/TelephonySettingsBroadsoft'
import TelephonySettingsKwebbl from './TelephonySettings/TelephonySettingsKwebbl'
import TelephonySettingsMetaswitch from './TelephonySettings/TelephonySettingsMetaswitch'
import TelephonySettingsSwyx from './TelephonySettings/TelephonySettingsSwyx'
import TelephonySettingsTapi from './TelephonySettings/TelephonySettingsTapi'
import TelephonySettingsTeams from './TelephonySettings/TelephonySettingsTeams'
import TelephonySettingsTelepo from './TelephonySettings/TelephonySettingsTelepo'
import TelephonySettingsVoclarion from './TelephonySettings/TelephonySettingsVoclarion'
import TelephonySettingsVoipCenter from './TelephonySettings/TelephonySettingsVoipCenter'
import TelephonySettingsVoipgrid from './TelephonySettings/TelephonySettingsVoipgrid'
import TelephonySettingsXelion from './TelephonySettings/TelephonySettingsVoipgrid'

//Embedded
import EmbeddedSalesforceSettings from "../Embedded/Salesforce/EmbeddedSalesforceSettings"
import EmbeddedZendeskSettings from "../Embedded/Zendesk/EmbeddedZendeskSettings"
import EmbeddedHubspotSettings from "../Embedded/Hubspot/EmbeddedHubSpotSettings"
import EmbeddedZohoSettings from "../Embedded/Zoho/EmbeddedZohoSettings"
import EmbeddedDynamicsSettings from "../Embedded/Dynamics/EmbeddedDynamicsSettings"
import UserSettingsIntegrations from "./UserSettingsIntegrations"
import { IsEmptyString } from "./GeneralFunctions";

const UserSettingsModal = (props) => {

    const cPushPublicVapidKey = "BJovlKvWRuqeCSbyyogJUuJZ3iOPlwF1JagAADr3E7zqtNb-c-oKm1MB3eptSuOuoNWlVfkBDgiPriKBU0N7ifI" //tbd: in one place

    const [mNotificationsBlockedByBrowser, SetNotificationsBlockedByBrowser] = useState(false)

    useEffect(() => {
        if (Notification.permission === "denied") {
            SetNotificationsBlockedByBrowser(true);
        }
    }, []);

    const DisableBrowserNotifications = () =>
    {
        PushApiSetBrowserNotificationSetting(props.SecurityToken, false).then(() => props.OnSetBrowserNotificationsActive(false)) 
    }

    const EnableBrowserNotifications = async () =>
    {
        props.OnSetBrowserNotificationsActive(false)

        const result = await Notification.requestPermission();
        if (result === 'denied') 
        {
            console.error('The user explicitly denied the permission request.');
            return;
        }
        else if (result === 'granted') 
        {
            console.info('The user accepted the permission request.');
        }

        navigator.serviceWorker.getRegistrations().then((registrations) => {
            const registration = registrations[0]
            console.log(registration)
            registration.pushManager.getSubscription().then((subscription) => {
            if (subscription) 
            {
                console.log('Service worker already subscribed')
                const key = subscription.getKey("p256dh")
                const encodedKey = key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null;
                const auth = subscription.getKey("auth")
                const encodedAuth = auth ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : null;
                PushApiSetBrowserNotificationSetting(props.SecurityToken, true).then(() => PushApiAddBrowserNotification(props.SecurityToken, "", subscription.endpoint, encodedKey, encodedAuth, Translate("Browser notifications activated")).then(() => props.OnSetBrowserNotificationsActive(true))) 
            }
            else
            {
                registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: UrlBase64ToUint8Array(cPushPublicVapidKey) })
                .then((subscription) => {
                    console.log('Service worker subscribe succeeded:', subscription)
                    const key = subscription.getKey("p256dh")
                    const encodedKey = key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null;
                    const auth = subscription.getKey("auth")
                    const encodedAuth = auth ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : null;
                    PushApiSetBrowserNotificationSetting(props.SecurityToken, true).then(() => PushApiAddBrowserNotification(props.SecurityToken, "", subscription.endpoint, encodedKey, encodedAuth, Translate("Browser notifications activated")).then(() => props.OnSetBrowserNotificationsActive(true)))  
                })
            }
            })
        })
    }

    const PaintEmbeddedSettings = () => {
        return (props.Embedded === "salesforce") ? <EmbeddedSalesforceSettings/> : 
            ((props.Embedded === "zendesk") ? <EmbeddedZendeskSettings/> : 
            (props.Embedded === "hubspot") ? <EmbeddedHubspotSettings/> : 
            (props.Embedded === "zoho") ? <EmbeddedZohoSettings/> : 
            (props.Embedded === "dynamics") ? <EmbeddedDynamicsSettings/> : 
            <></>)
    }

    const RegisterProtocol = () => {
        const protocolURL = window.location.href + "?action=makecall&number=%s"
        navigator.registerProtocolHandler("tel", protocolURL, "CloudCTI webclient")
    }

    const ResetProtocolSettings = () => {
        window.location.href = "ms-settings:defaultapps";

        /*
        if (window.chrome) //copilot said to also check window.chrome.webstore but that doesn't exist
        {
            window.location.href = "chrome://settings/handlers"
        }
        else if (typeof InstallTrigger !== 'undefined')
        {
            window.location.href = "about:preferences#applications"
        }
        else if (navigator.userAgent.includes("Edg"))
        {
            window.location.href = "edge://settings/content/handlers"
        } 
        */
    }

    const SetThemeEx = (theme) => {
        SetTheme(theme)
        window.location.reload()
    }

    const UpdatePhoneSettings = () => {
        props.OnUpdatePhoneSettings()
    }
    
    return (
        <Modal size="lg" scrollable={true} animation={false} show={true} onHide={() => props.OnHide()} className="scrollbary">
            <Modal.Header className="main" closeButton>
                <Modal.Title>{props.OnlyShowPhoneSettings ? Translate("Phone settings") : Translate("User settings")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="main">

                <table width="100%" cellPadding={16}>
                <tbody>
                {!props.OnlyShowPhoneSettings ? <>
                    <tr className="usersettings">
                        <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Signed in as")}</td>
                        <td width="*" valign="center">{props.UserName + " (" + props.Email + ")"}</td>
                    </tr>
                    <tr className="usersettings">
                        <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Your organization")}</td>
                        <td width="*" valign="center">{props.TenantName}</td>
                    </tr>
                    <tr className="usersettings">
                        <td width="200" className="foregroundlightasbackground" valign="center">{Translate("License")}</td>
                        <td width="*" valign="center">
                            {props.LicenceName}<br/>
                            <span className="smalltext">{Translate("Telephony platform")}: {props.LicencePlatforms}</span><br/>
                            <span className="smalltext">{Translate("Click-to-call")}: {Translate("yes")}</span><br/>
                            <span className="smalltext">{Translate("Caller recognition and scripts")}: {props.LicenceRecognitionAndScreenpop ? Translate("yes") : Translate("no")}</span>
                        </td>                                                                                 
                    </tr>
                    <tr className="usersettings">
                        <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Language")}</td>
                        <td width="*" valign="center">
                        <select name="Language" style={{ paddingLeft: "2px", width: "120px" }} onChange={evt => props.OnUpdateLanguage(evt.target.value)} value={props.LanguageId === "nederlands" ? "nederlands" : ""}>
                            <option value="">English</option>
                            <option value="nederlands">Nederlands</option>
                        </select>        
                        </td>
                    </tr>
                    {!IsEmptyString(props.Embedded) ? <></> : 
                        <tr className="usersettings">
                            <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Theme")}</td>
                            <td width="*" valign="center">
                            <select name="Language" style={{ paddingLeft: "2px", width: "120px" }} onChange={evt => SetThemeEx(evt.target.value)} value={GetTheme() === "dark" ? "dark" : "light"}>
                                <option value="light">Light</option>
                                <option value="dark">Dark</option>
                            </select>      
                            </td>
                        </tr>}
                    <tr className="usersettings" height="20"/></> : <></>}
                    <tr className="usersettings">
                    {!props.OnlyShowPhoneSettings ?<td width="200" className="foregroundlightasbackground" valign="center">{Translate("Telephony")}</td> : <></>}
                    <td width="*" valign="center">
                        {props.PhoneApiError ? <div className="error">{props.PhoneApiError}</div> : <div className="ok">{Translate("Your phone is connected")}</div>}
                        {
                            props.PhoneSettingsTemplate === "Amiba" ? <TelephonySettingsAmiba MyConnect={false} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Avaya" ? <TelephonySettingsAvaya MyConnect={false} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Broadsoft2014" ? <TelephonySettingsBroadsoft MyConnect={false} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Kwebbl" ? <TelephonySettingsKwebbl PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()} OnPhoneSubscribe={() => props.OnPhoneSubscribe()}/> :
                            props.PhoneSettingsTemplate === "MyConnect" ? <TelephonySettingsTelepo MyConnect={true} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Metaswitch" ? <TelephonySettingsMetaswitch PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()} OnPhoneSubscribe={() => props.OnPhoneSubscribe()}/> :
                            props.PhoneSettingsTemplate === "Swyx" ? <TelephonySettingsSwyx MyConnect={true} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Tapi" ? <TelephonySettingsTapi MyConnect={false} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Teams" ? <TelephonySettingsTeams PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Telepo" ? <TelephonySettingsTelepo MyConnect={false} PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "VoipCenter" ? <TelephonySettingsVoipCenter PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "VoipGrid" ? <TelephonySettingsVoipgrid PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Voclarion" ? <TelephonySettingsVoclarion PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            props.PhoneSettingsTemplate === "Xelion" ? <TelephonySettingsXelion PhoneSettings={props.PhoneSettings} OnUpdatePhoneSettings={() => UpdatePhoneSettings()}/> :
                            <></>
                        }
                    </td>
                </tr>
                {!props.OnlyShowPhoneSettings ? <>
                    {!IsEmptyString(props.Embedded) ? <></> : 
                        <tr className="usersettings">
                            <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Dialer URL Protocol")}</td>
                            <td width="*" valign="center">                       
                                <div className="hyperlink" onClick={() => RegisterProtocol()}>{Translate("Register tel:// protocol")}</div>
                                <div className="hyperlink" onClick={() => ResetProtocolSettings()}>{Translate("Reset protocol settings")}</div>
                            </td>
                        </tr>}
                    {!IsEmptyString(props.Embedded) ? <></> : 
                        <tr className="usersettings" height="20"/>}
                    {!IsEmptyString(props.Embedded) ? <></> : 
                        <tr className="usersettings">
                            <td width="200" className="foregroundlightasbackground" valign="center">{Translate("CRMs and scripts")}</td>
                            <td width="*" valign="center">
                                <UserSettingsIntegrations SecurityToken={props.SecurityToken} Integrations={props.Integrations}/>
                                <br/>
                                {props.CallFieldScripts.map(
                                    (callfieldscript,index) => <div key={index}><img src={GetTheme() === "dark" ? ActionPngDark : ActionPngLight} className="foregroundasbackground" width="24"/>{callfieldscript}</div>
                                )}

                                {props.UserIsAdmin ? <br height="8"/> : <span/>}
                                {props.UserIsAdmin ? <div className="hyperlink" onClick={() => props.OnOpenWebConfigurator()}>{Translate("Click here to open the webconfigurator to configure your CRM")}</div> : <span/>}                      
                            </td>
                        </tr>}
                    {!IsEmptyString(props.Embedded) ? <></> :  
                        <tr className="usersettings">
                            <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Browser notifications")}</td>
                            <td width="*" valign="center">
                                { props.BrowserNotificationsActive ? 
                                    <div>{Translate("Browser notifications are currently enabled")}</div> :
                                    <div>{Translate("Browser notifications are currently disabled")}</div>
                                }
                                {  mNotificationsBlockedByBrowser ? 
                                    <div style={{ color: "red"}}>{Translate("Notifications are blocked by your browser! Enable them in your browser settings.")}</div> :
                                    <></>
                                }
                                { props.BrowserNotificationsActive ? 
                                    <span className="hyperlink" onClick={() => DisableBrowserNotifications()}>{Translate("Disable")}</span> :
                                    <span className="hyperlink" onClick={() => EnableBrowserNotifications()}>{Translate("Enable")}</span>
                                }
                                
                            </td>
                        </tr>}
                    {PaintEmbeddedSettings()}
                </> : <></>}

                    <tr className="usersettings" height="20"/>
                    <tr className="usersettings">
                        <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Version")}</td>
                        <td width="*" valign="center">{packageJson.version}</td>
                    </tr>
                </tbody>
                </table>

            </Modal.Body>
        </Modal>
    )
}

UserSettingsModal.propTypes = {
    SecurityToken: PropTypes.string,
    Email: PropTypes.string,
    UserName: PropTypes.string,
    TenantName: PropTypes.string,
    LicenceName: PropTypes.string,
    LicencePlatforms: PropTypes.string,
    LicenceRecognitionAndScreenpop: PropTypes.bool,
    LanguageId: PropTypes.string,
    Integrations: PropTypes.array,
    CallFieldScripts: PropTypes.array,
    UserIsAdmin: PropTypes.bool,
    BrowserNotificationsActive: PropTypes.bool,
    PhoneApiError: PropTypes.string,
    PhoneSettingsTemplate: PropTypes.string,
    PhoneSettings: PropTypes.object,
    Embedded: PropTypes.string,
    OnlyShowPhoneSettings: PropTypes.bool,
    OnHide: PropTypes.func,
    OnSetBrowserNotificationsActive: PropTypes.func,
    OnUpdateLanguage: PropTypes.func,
    OnUpdatePhoneSettings: PropTypes.func,
    OnPhoneSubscribe: PropTypes.func,
    OnTranslate: PropTypes.func,
    OnOpenWebConfigurator: PropTypes.func
  }

export default UserSettingsModal